export default __webpack_public_path__ + "static/media/login.ed89de01.svg";